import { toast, ToastContainer } from 'react-toastify'
import * as Yup from "yup"
import { useFormik } from "formik"
import { request } from "../../services/request"
import { Form } from "react-bootstrap"
import PrimaryButton from '../../components/subComponents/PrimaryButton'
import SecondaryButton from '../../components/subComponents/SecondaryButton'
import { useCallback, useEffect, useState } from 'react'
import ToggleSwitch from '../../components/common/ToggleSwitch'
import { changeloaderState } from '../../store/loaderSlice'
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../store/store"
import { UpdateAppVersion, UpdateAppVersionResponse } from '../../services/authinterface'

const AppVersions = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [appVersionsData, setAppVersionsData] = useState<UpdateAppVersion | null>(null)
    const dispatch = useDispatch<AppDispatch>()
    const validationSchema = Yup.object().shape({
        ios: Yup.string().trim().required("Please enter IOS Version"),
        android: Yup.string().trim().required("Please enter Android Version"),
        iosForce: Yup.boolean(),
        androidForce: Yup.boolean(),
    })

    const fetchAppVersions = useCallback(async () => {
        try {
            dispatch(changeloaderState(true))

            const response = await request<UpdateAppVersionResponse>({
                url: `/adminPaySetting/getVersions`,
                method: "GET",
            })

            if (response.success) {
                setAppVersionsData(response.data)
            } else {
                toast.error("Failed to App Version: " + response.message)
            }
        } catch (error) {
        } finally {
            dispatch(changeloaderState(false))
        }
    }, [dispatch])

    useEffect(() => {
        fetchAppVersions()
    }, [fetchAppVersions])

    const formik = useFormik({
        initialValues: {
            ios: appVersionsData?.ios || "",
            android: appVersionsData?.android || "",
            iosForce: appVersionsData?.iosForce || false,
            androidForce: appVersionsData?.androidForce || false,
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                setLoading(true)
                const response = await request<UpdateAppVersionResponse>({
                    url: `/adminPaySetting/updateVersions`,
                    method: "POST",
                    data: values,
                })
                if (response.success) {
                    toast.success(response.message)
                    fetchAppVersions()
                } else {
                    toast.error(response.message)
                }
            } catch (error: any) {
                toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
            } finally {
                setLoading(false)
            }
        },
    })

    return (
        <section className='dashboard-section'>
            <ToastContainer position='top-right' autoClose={2000} theme='light' />
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-12'>
                        <div className='d-flex gap-1 mb-2'>
                            <div className='dashboard-table-title-section title-line w-100'>
                                <h2>App Version</h2>
                            </div>
                        </div>
                    </div>
                    <div className='col-xl-8 col-lg-10 col-md-10 col-12 mt-4 w-100'>
                        <form onSubmit={formik.handleSubmit} className='customer-edit-form'>
                            <div className='row'>
                                <div className='col-12 col-sm-6'>
                                    <div className='form-group login-input-section'>
                                        <label htmlFor='title'>IOS Version</label>
                                        <Form.Control
                                            type='text'
                                            className='form-control'
                                            id='ios'
                                            name='ios'
                                            placeholder='Enter IOS Version'
                                            value={formik.values.ios}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isInvalid={!!(formik.errors.ios && formik.touched.ios)}
                                        />

                                        <span className='text-red-500 text-xs'>
                                            {formik.touched.ios && formik.errors.ios?.toString()}
                                        </span>
                                    </div>
                                    <ToggleSwitch
                                        isOn={formik.values.iosForce}
                                        handleToggle={() =>
                                            formik.setFieldValue('iosForce', !formik.values.iosForce)
                                        }
                                        onLabel='Force iOS App Update'
                                        offLabel='Force iOS App Update'
                                    />
                                </div>
                                <div className='col-12 col-sm-6 mt-4 mt-sm-0'>
                                    <div className='form-group login-input-section'>
                                        <label htmlFor='title'>Android Version</label>
                                        <Form.Control
                                            type='text'
                                            className='form-control'
                                            id='android'
                                            name='android'
                                            placeholder='Enter Android Version'
                                            value={formik.values.android}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            isInvalid={!!(formik.errors.android && formik.touched.android)}
                                        />
                                        <span className='text-red-500 text-xs'>
                                            {formik.touched.android && formik.errors.android?.toString()}
                                        </span>
                                    </div>
                                    <ToggleSwitch
                                        isOn={formik.values.androidForce}
                                        handleToggle={() =>
                                            formik.setFieldValue(
                                                'androidForce',
                                                !formik.values.androidForce
                                            )
                                        }
                                        onLabel='Force Android App Update'
                                        offLabel='Force Android App Update'
                                    />
                                </div>
                            </div>
                            <div className='col-xl-8 col-lg-10 col-md-10 col-12 mt-4 w-100'>
                                <div className='d-flex gap-3 justify-content-center'>
                                    <div className='d-flex gap-3'>
                                        <PrimaryButton
                                            type='submit'
                                            label={loading ? 'Submitting...' : "Submit"}
                                            className='editFormButton w-100'
                                            disabled={loading}
                                        />
                                        <SecondaryButton
                                            type='button'
                                            onClick={() => {
                                                formik.resetForm()
                                            }}
                                            label='Cancel'
                                            className='editFormButton w-100'
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div></section>
    )
}

export default AppVersions
